import React, {MouseEvent} from 'react';
import MicrosoftButton from "../Button/MicrosoftButton";
import IconMicrosoft from "../Icons/Microsoft/IconMicrosoft";
import styled from "styled-components";
import {WerfenColor3, White} from "../../Constants/ColorChart";

const StyledSectionTitle = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  color: ${White};
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin: 24px 0;
  &::before, &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid ${WerfenColor3};
  }
  &:not(:empty)::before {
    margin-right: 12px;
  }
  &:not(:empty)::after {
    margin-left: 12px;
  }
`;

const StyledExternalSectionTitle = styled(StyledSectionTitle)`
  margin-top: 56px;
`;

const StyledText = styled.div`
  font-size: 12px;
  color: ${WerfenColor3};
  margin-top: 8px;
  text-align: center;
`;

type LoginMicrosoftProps = {
    handleClick: (event: MouseEvent<HTMLDivElement>) => void;
    disabled?: boolean;
};

const LoginMicrosoft: React.FC<LoginMicrosoftProps> = ({handleClick, disabled}) => {
    const onClick = (event: MouseEvent<HTMLDivElement>) => {
        if (!disabled) {
            handleClick(event);
        }
    }

    return (
        <div>
            <StyledSectionTitle>Werfen employees</StyledSectionTitle>
            <MicrosoftButton
                centered
                miniSized
                Text={IconMicrosoft}
                onClick={onClick}
                disabled={disabled ?? false}
            />
            <StyledText>Use your @werfen.com account · single sign-on</StyledText>
            <StyledExternalSectionTitle>External users</StyledExternalSectionTitle>
        </div>
    );
};

export default LoginMicrosoft;